var map = {
	"./action.png": 5429,
	"./action_2.png": 3910,
	"./alien.png": 6590,
	"./cyberpunk.png": 8820,
	"./fantasy.png": 309,
	"./fantasy_2.png": 6614,
	"./ghost.png": 4382,
	"./historical.png": 5687,
	"./historical_2.png": 3296,
	"./horror.png": 6367,
	"./horror_2.png": 7672,
	"./mystery.png": 5692,
	"./mystery_2.png": 6279,
	"./poetry.png": 3088,
	"./romance.png": 4788,
	"./scifi.png": 4219,
	"./scifi_2.png": 7692,
	"./steampunk.png": 9723,
	"./thriller.png": 6741,
	"./thriller_2.png": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8428;